import React from 'react'
import { Link } from 'react-router-dom'
import classnames from 'classnames'
import CookUnityLogo from '../../assets/img/logo-cookunity.png'
import Close from '../../assets/img/close-outline.png'
import { mainLinks } from './constants'

const mapMenuItem = (link, index, onClose) => {
  const Component =
    link.component === 'a' ? (
      <a href={link.pathname} target="_blank">
        {link.label}
      </a>
    ) : (
      <Link to={link.pathname} onClick={onClose}>
        {link.label}
      </Link>
    )

  return (
    <div
      key={index}
      className={classnames('menu_item', { mobile_only: link.mobileOnly })}>
      {Component}
      {link.new && <span className="new_tag">new</span>}
    </div>
  )
}

const UserMenu = props => {
  const { isOpen, onClose } = props

  return (
    isOpen && (
      <div className="cookunity__user_menu">
        <div className="menu_header">
          <div className="close_button" onClick={onClose}>
            <img src={Close} alt="close icon" />
          </div>
          <div className="logo">
            <Link to="/">
              <img src={CookUnityLogo} alt="cookunity logo" />
            </Link>
          </div>
        </div>
        <div className="menu_section mobile_only">
          {mainLinks.map((link, index) => mapMenuItem(link, index, onClose))}
        </div>
        <div className="menu_section">
          <Link className="menu_item" to="/logout">
            Log out
          </Link>
        </div>
      </div>
    )
  )
}

export default UserMenu



// WEBPACK FOOTER //
// ./src/modules/Header/UserMenu.jsx